import React from 'react';
import { Briefcase } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RoleData {
  id: string;
  name: string;
  day_rate?: number;
  hourly_rate?: number;
}

interface RolesRatesCardProps {
  roles: RoleData[];
}

export const RolesRatesCard: React.FC<RolesRatesCardProps> = ({ roles }) => {
  if (roles.length === 0) {
    return (
      <div className="bg-surface-1 border border-border rounded p-4">
        <h2 className="font-heading text-sm uppercase tracking-wider text-muted-foreground mb-2">
          Roles & Rates
        </h2>
        <p className="text-sm text-muted-foreground">No roles configured for this client.</p>
      </div>
    );
  }

  return (
    <div className="bg-surface-1 border border-border rounded p-4">
      <h2 className="font-heading text-sm uppercase tracking-wider text-muted-foreground mb-3">
        Roles & Rates
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
        {roles.map((role) => (
          <div
            key={role.id}
            className="flex items-center gap-2.5 bg-surface-2 border border-border rounded px-3 py-2"
          >
            <Briefcase className="h-4 w-4 text-primary flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-heading uppercase tracking-wider text-foreground truncate">
                {role.name}
              </div>
            </div>
            <div className="text-right flex-shrink-0">
              {role.day_rate != null ? (
                <span className="font-mono text-sm text-primary">
                  ${role.day_rate.toFixed(0)}
                  <span className="text-xs text-muted-foreground">/day</span>
                </span>
              ) : role.hourly_rate != null ? (
                <span className="font-mono text-sm text-primary">
                  ${role.hourly_rate.toFixed(0)}
                  <span className="text-xs text-muted-foreground">/hr</span>
                </span>
              ) : (
                <span className="text-xs text-muted-foreground">No rate</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
